function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestopsReportsInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6,3.5a1,1,0,0,1,1,.88v.06l4.39,2.27a1,1,0,0,1,.49-.2H12a1,1,0,0,1,1,1h0l4.43,2.17A1,1,0,0,1,18,9.5a1,1,0,0,1,1,1,1,1,0,0,1-.16.5L23,13.1V3a2,2,0,0,0-2-2H3A2,2,0,0,0,1.21,2.12l3.89,2A1,1,0,0,1,6,3.5Z",
    style: {
      fill: "#b4cefa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,21a2,2,0,0,0,2,2H21a2,2,0,0,0,2-2V13.1L18.84,11a1,1,0,0,1-.84.5,1,1,0,0,1-1-.88v0l-4.51-2.2a1,1,0,0,1-.37.12H12a1,1,0,0,1-1-.86L6.55,5.34A1,1,0,0,1,6,5.5a1,1,0,0,1-.9-1.42l-3.89-2A2,2,0,0,0,1,3Zm2.5-2.5h1V8.5a1,1,0,0,1,1-1h1a1,1,0,0,1,1,1v10h3v-7a1,1,0,0,1,1-1h1a1,1,0,0,1,1,1v7h3v-4a1,1,0,0,1,1-1h1a1,1,0,0,1,1,1v4h1a.5.5,0,0,1,0,1H3.5a.5.5,0,0,1,0-1Z",
    style: {
      fill: "#d2e1fa"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestopsReportsInactive);
export default __webpack_public_path__ + "static/media/testops_reports_inactive.4bbc81234e87cca319676dfd41e34af6.svg";
export { ForwardRef as ReactComponent };